import { useEffect, useRef, useState } from 'react';
import { useTheme, type ThemeChoice } from '@/app/providers/ThemeProvider';

const OPTIONS: { value: ThemeChoice; label: string; icon: string }[] = [
  { value: 'light', label: 'Цайвар', icon: 'sun' },
  { value: 'dark', label: 'Бараан', icon: 'moon' },
  { value: 'system', label: 'Систем', icon: 'display' },
];

export function ThemeToggle() {
  const { setChoice } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="ts-toggle-btn"
        onClick={() => setOpen((x) => !x)}
        title="Theme"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <i className="bi bi-circle-half" />
      </button>
      {open ? (
        <div
          role="menu"
          className="ts-card"
          style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 6px)',
            padding: 6,
            minWidth: 160,
            zIndex: 300,
          }}
        >
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              role="menuitem"
              className="ts-nav-item"
              style={{ width: '100%', justifyContent: 'flex-start', color: 'var(--bs-body-color)' }}
              onClick={() => {
                setChoice(opt.value);
                setOpen(false);
              }}
            >
              <i className={`bi bi-${opt.icon}`} /> {opt.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
